import { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";

/* ------------------ MENU CONFIG ------------------ */

const NAV_ITEMS = [
  {
    label: "What We Do",
    key: "services",
    children: [
      {
        label: "Infrastructure Managed Services",
        key: "infra-services",
        children: [
          { label: "End User Managed Services", path: "/end-user-managed" },
          { label: "Application Managed Services", path: "/application-managed" },
          { label: "Global Delivery Center", path: "/global-delivery" },
          { label: "Data Center Managed Services", path: "/infs-data-center" },
          { label: "Hybrid Cloud Managed Services", path: "/hybrid-cloud" },
          { label: "End User Amc", path: "/end-user-amc" },
          { label: "Cisco Powered Managed Services", path: "/cisco-powered-managed" },
          { label: "Cisco Meraki", path: "/cisco-meraki" },
          { label: "Cisco Catalyst", path: "/cisco-catalyst" },
        ],
      },
      {
        label: "Infrastructure Solutions",
        key: "infra-solution",
        children: [
          { label: "End User Solution", path: "/infs-end-user" },
          { label: "Meeting Solutions", path: "/infs-meeting" },
          { label: "Data Center", path: "/infs-data-center" },

        ],
      },
      {
        label: "Cyber Security",
        key: "cyber-services",
        children: [
          { label: "End Point Security", path: "/cyber-endpoint" },
          { label: "Cloud Security", path: "/cyber-cloud" },
          { label: "Application Security", path: "/cyber-application" },
          { label: "Network Security", path: "/cyber-network" },
          { label: "Operational Security", path: "/cyber-operational" },
        ],
      },
      {
        label: "Cloud Solutions",
        key: "cloud-services",
        children: [
          { label: "Cloud Amazon", path: "/cloud-amazon" },
          { label: "Cloud Azure", path: "/cloud-azure" },
          { label: "Cloud Google", path: "/cloud-google" },
          { label: "Cloud Managed", path: "/cloud-managed" },
          { label: "Cloud Migration", path: "/cloud-migration" },
        ],
      },
      { label: "ERP & Business Application", path: "/erp-business-analyst" },
    ],
  },
  {
    label: "Industries",
    key: "industries",
    children: [
      { label: "Retail", path: "/retail" },
      { label: "IT/ITES", path: "/it-ites" },
    ],
  },
  { label: "Who We Are", path: "/who-we-are" },
  { label: "Careers", path: "/career" },
  {
    label: "Insights",
    key: "insights",
    children: [
      { label: "Events", path: "/events" },
      // Add Blogs later if implemented
    ],
  },
  { label: "Contact Us", path: "/contact" },
];


/* ------------------ COMPONENT ------------------ */

function Navbar() {
  const [openMenus, setOpenMenus] = useState({});
  const [mobileMenu, setMobileMenu] = useState(false);
  const [sticky, setSticky] = useState(false);
  const navRef = useRef(null);

  /* -------- Sticky Navbar -------- */

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  /* -------- Close on Outside Click + ESC -------- */

  useEffect(() => {
    const handleClose = (e) => {
      if (e.type === "keydown" && e.key === "Escape") {
        setOpenMenus({});
        setMobileMenu(false);
      }

      if (
        e.type === "mousedown" &&
        navRef.current &&
        !navRef.current.contains(e.target)
      ) {
        setOpenMenus({});
        setMobileMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClose);
    document.addEventListener("keydown", handleClose);

    return () => {
      document.removeEventListener("mousedown", handleClose);
      document.removeEventListener("keydown", handleClose);
    };
  }, []);

  /* -------- Toggle Dropdown -------- */

  const toggleDropdown = (key) => {
    setOpenMenus((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const closeAll = () => {
    setOpenMenus({});
    setMobileMenu(false);
  };

  /* -------- Recursive Menu Renderer -------- */

  const renderMenuItems = (items, level = 0) => {
    return items.map((item) => {
      const hasChildren = item.children && item.children.length > 0;

      return (
        <li
          key={item.key || item.path}
          className={`menu-item level-${level} ${hasChildren && openMenus[item.key] ? "open" : ""
            }`}
        >
          {hasChildren ? (
            <>
              <button
                type="button"
                onClick={() => toggleDropdown(item.key)}
                aria-haspopup="true"
                aria-expanded={openMenus[item.key] || false}
              >
                {item.label}
                <span className="arrow">▾</span>
              </button>

              <ul className="dropdown-menu">
                {renderMenuItems(item.children, level + 1)}
              </ul>
            </>
          ) : (
            <NavLink
              to={item.path}
              onClick={closeAll}
              className={({ isActive }) =>
                isActive ? "active-link" : ""
              }
            >
              {item.label}
            </NavLink>
          )}
        </li>
      );
    });
  };

  /* ------------------ RENDER ------------------ */

  return (
    <nav
      ref={navRef}
      className={`navbar ${sticky ? "sticky" : ""}`}
      role="navigation"
    >
      {/* LOGO */}
      <div className="logo">
        <NavLink to="/" onClick={closeAll}>
          ZETNTECH
        </NavLink>
      </div>

      {/* MENU */}
      <ul className={`menu ${mobileMenu ? "active" : ""}`}>
        {renderMenuItems(NAV_ITEMS)}
      </ul>

      {/* HAMBURGER */}
      <button
        className={`hamburger ${mobileMenu ? "open" : ""}`}
        onClick={() => setMobileMenu((prev) => !prev)}
        aria-label="Toggle Menu"
        aria-expanded={mobileMenu}
      >
        <span />
        <span />
        <span />
      </button>
    </nav>
  );
}

export default Navbar;
